<template>
  <div class="generalPage">
    <div class="isotopeGrid">

      <div class="section1">
        <div class="title_wrapper">
          <p class="title">
            寵物家居安全
          </p>
          <p class="subTitle">
            如何令您的寵物遠離危險
          </p>
        </div>
      </div>

      <div class="section2">
        <div class="generalWrapper">
          <div class="img"><img src="../assets/pets.png"></div>
          <div class="txt_group">
            <h1>寵物家居安全</h1>
            <p>在家中使用任何類型的殺蟲產品時，產品安全是最為重要的考慮因素，尤其是家中有飼養寵物的用家。威滅產品是專門為針對曱甴和螞蟻而設計，對寵物來說只有極微量毒性。少量的藥餌對寵物的影響不大，但仍然建議採取一些預防措施來保護您家居的寵物。</p>
          </div>

          <div class="txt_group">
            <h1 class="clear">4個寵物安全小貼士</h1>
            <ol>
              <li>使用前必須閱讀及遵照標籤指示，不要超過建議使用量。</li>
              <li>請將藥餌遠離寵物籠、食物或水碗，避免寵物觸及。</li>
              <li>請保持藥餌盒完整，不要強行打開餌盒。</li>
              <li>請放置藥餌盒於孩童及寵物不能觸及的地方。</li>
            </ol>
          </div>

          <div class="txt_group">
            <p>如對於產品有任何疑問，請致電查詢熱線：2895 9515</p>
          </div>
        </div>
      </div>

    </div>
    <contact></contact>
    <henkel-footer></henkel-footer>
  </div>
</template>

<script>
export default {
  created () {
    window.document.title = '威滅Combat 速效藥餌'
    window.scrollTo(0, 0)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import "../styles/_vars.sass"
@import "../styles/_isotopeGrid.sass"

.generalPage
  padding-top: $topMenu-height

  .img
    float: right
    width: 372px
    width: 30%
    margin: 0 0 18px 0
    text-align: center

    @media only screen and (max-width: 959px)
      width: 100%

    img
      float: none !important
      width: 100% !important

      @media only screen and (max-width: 959px)
        width: 50% !important

      @media only screen and (max-width: 959px)
        width: 70% !important

  .txt_group
    display: block
    float: left
    width: 67%
    margin-bottom: 18px

    @media only screen and (max-width: 959px)
      width: 100%

  .clear
    clear: both

</style>



// WEBPACK FOOTER //
// PTipsPetSafety.vue?2f302570